import React from 'react';
import { Briefcase } from 'react-feather';

function IncomeGrid({ formData, onDataChange }) {
  return (
    <div className="form-section">
      <div className="content-box-header">
        <h2><Briefcase size={20} className="icon-orange" /> Business Income </h2>
      </div>

      <div className="dependent-card">
        <div className="form-group">
          <label style={{ fontWeight: 600, color: '#554833ff' }}>Net Business Income (Schedule 1, Line 3)</label>
          <p style={{ fontSize: '0.9rem', color: '#8b7764ff', marginBottom: '0.75rem' }}>
            Enter the final Net Profit (or Loss) from your self-employment activity.
          </p>
          <div className="input-with-prefix">
            <span className="prefix">$</span>
            <input 
              type="number" 
              name="manualBusinessIncome" 
              value={formData?.manualBusinessIncome ?? ''} 
              onChange={onDataChange} 
              placeholder="0" 
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default IncomeGrid;